import $ from 'jquery'

/**
 * Tracks the x,y coordinates of the mouse. This is helpful when you need to know
 * where the mouse is, but you don't have a current mouse event to work with
 */
class MouseTracker {
	constructor () {
		$(document.body).on('mousemove', e => this.onMouseMove(e))
	}

	onMouseMove (e) {
		this.x = e.clientX
		this.y = e.clientY
	}

	/**
	 * Returns the current x,y coordinates of the mouse
	 *
	 * @returns {{x: Int, y:Int}}
	 */
	coords () {
		return { x: this.x, y: this.y }
	}
}

export default new MouseTracker()
